import { ContractDtoToEntity } from "src/app/features/Contract/services/mappers/ContractDtoToEntity";
import type { ContractDto } from "src/app/features/Contract/types/ContractDto";
import type { ContractEntity } from "src/app/features/Contract/types/ContractEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const ContractTableDtoMapper = (input: Readonly<ResourcePageDto<ContractDto>>): ResourcePageEntity<ContractEntity> => {
    return {
        list: input.list ? input.list.map(ContractDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
